export enum ProgramActionKeys {
  DELETE_CASH_DISCOUNT = 'DELETE_CASH_DISCOUNT',
  DELETE_PROGRAM_GROUP = 'DELETE_PROGRAM_GROUP',
  DELETE_PROGRAM_LEVEL = 'DELETE_PROGRAM_LEVEL',
  FETCH_PRESEASON_PROGRAM_SETUP = 'FETCH_PRESEASON_PROGRAM_SETUP',
  FETCH_CASH_DISCOUNTS = 'FETCH_CASH_DISCOUNTS',
  FETCH_PROGRAMS = 'FETCH_PROGRAMS',
  QUERY_CASH_DISCOUNT = 'QUERY_CASH_DISCOUNT',
  REMOVE_CASH_DISCOUNT = 'REMOVE_CASH_DISCOUNT',
  REMOVE_PROGRAM_GROUP = 'REMOVE_PROGRAM_GROUP',
  REMOVE_PROGRAM_LEVEL = 'REMOVE_PROGRAM_LEVEL',
  SET_CASH_DISCOUNTS = 'SET_CASH_DISCOUNTS',
  SET_DEALER_CASH_DISCOUNT = 'SET_DEALER_CASH_DISCOUNT',
  SET_MAX_PROGRAM_FISCAL = 'SET_MAX_PROGRAM_FISCAL',
  SET_PRESEASON_PROGRAM_SETUP = 'SET_PRESEASON_PROGRAM_SETUP',
  SET_PROGRAMS = 'SET_PROGRAMS',
  SET_PROGRAM_GROUPS = 'SET_PROGRAM_GROUPS',
  SET_PROGRAM_LEVELS = 'SET_PROGRAM_LEVELS',
  UPDATE_CASH_DISCOUNT = 'UPDATE_CASH_DISCOUNT',
  UPDATE_PROGRAM_GROUP = 'UPDATE_PROGRAM_GROUP',
  UPDATE_PROGRAM_LEVEL = 'UPDATE_PROGRAM_LEVEL',
  UPDATE_PROGRAM_PRESEASON_SETUP = 'UPDATE_PROGRAM_PRESEASON_SETUP'
}
